import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

export interface Status {
    message: string;
    inProgress: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class MailingService {

    constructor(private httpClient: HttpClient) {

    }

    sendEmails(emailsFileName: string, templateId: string, campaign: string): Observable<any> {
        const body = {
            emailsFileName: emailsFileName,
            templateId: templateId,
            campaign: campaign
        };

        return this.httpClient.post('/mailing-flow', body, {withCredentials: true})
    }

    getStatus(): Observable<Status> {
        return this.httpClient.get<Status>( '/mailing-flow/status', {withCredentials: true});
    }
}
